import { configureStore } from '@reduxjs/toolkit'
import financialReducer from 'slices/financial'
import modalReducer from './slices/modal'
import customerReducer from './slices/customer'
import contractReducer from './slices/contract'
import alertReducer from './slices/alert'
import drawerReducer from './slices/drawer'
import chatReducer from './slices/chat'
import massiveReducer from './slices/massive'
import wifiReducer from './slices/wifi'
import serviceOrderReducer from './slices/serviceOrder'
import storeReducer from './slices/store'
import bannerReducer from './slices/banners'
import paymentReducer from './slices/payment'
import parametersReducer from './slices/parameter'
import messagesReducer from './slices/messages'

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    customer: customerReducer,
    contract: contractReducer,
    alert: alertReducer,
    drawer: drawerReducer,
    chat: chatReducer,
    massive: massiveReducer,
    wifi: wifiReducer,
    serviceOrder: serviceOrderReducer,
    store: storeReducer,
    banners: bannerReducer,
    payments: paymentReducer,
    parameters: parametersReducer,
    messages: messagesReducer,
    financial: financialReducer,
  },
})
